import { render, staticRenderFns } from "./ProductDetailBasicModule.vue?vue&type=template&id=df45b304&scoped=true"
import script from "./ProductDetailBasicModule.vue?vue&type=script&lang=js"
export * from "./ProductDetailBasicModule.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailBasicModule.vue?vue&type=style&index=0&id=df45b304&prod&scoped=true&lang=css"
import style1 from "./ProductDetailBasicModule.vue?vue&type=style&index=1&id=df45b304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df45b304",
  null
  
)

export default component.exports